/**
 * Request headers for the concurrency and idempotency rules of the contract (CLAUDE.md §10, openapi.yaml conventions).
 * Feature `api/` mutations spread these into `params.header`:
 *
 *   api.POST('/deals/{dealId}/hold', { params: { path: { dealId }, header: { ...ifMatch(version), ...idempotent() } }, body })
 *
 * - `idempotent()` makes ONE key per user action: call it inside the mutationFn, so a user retry (a new click) is a new
 *   action, while the server replays the stored response if the same request is re-sent (network retry).
 * - `ifMatch(version)` sends the version of the record (or owning aggregate) the user last saw; a stale one gets 409.
 */
import { newIdempotencyKey } from '@/shared/lib/identifiers';

export function idempotent(): { 'Idempotency-Key': string } {
  return { 'Idempotency-Key': newIdempotencyKey() };
}

export function ifMatch(version: string): { 'If-Match': string } {
  return { 'If-Match': version };
}

/** If-Match only when a version is known (operations where the contract still marks it optional). */
export function ifMatchOptional(version: string | null | undefined): { 'If-Match'?: string } {
  return version ? { 'If-Match': version } : {};
}
